import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c2998b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "infrastructure_view" }
const _hoisted_2 = { class: "card_content" }
const _hoisted_3 = { class: "card_label" }
const _hoisted_4 = { class: "card_text" }

import ContentViewVue from '@/components/ContentView.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'InfrastructureView',
  setup(__props) {

const getBackGroundImage = (index:number) => require(`@/assets/service/service_tag_0${index}.png`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ContentViewVue, null, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (item, index) => {
            return _createElementVNode("div", {
              class: "card",
              key: index,
              style: _normalizeStyle({'background-image': `url(${getBackGroundImage(index)})`})
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`service.SERVICE_CARD_LABEL_${index}`)), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(`service.SERVICE_CARD_TEXT_${index}`)), 1)
            ], 4)
          }), 64))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})